<template>
  <v-container>
    <v-row>
      <v-col><v-btn block color="green" @click="newOnClick">Add</v-btn></v-col>
    </v-row>
    <v-row v-if="selectedTextArea">
      <v-col>
        <v-chip v-for="slug in availableSlugs" :key="slug.value"
                class="ma-2"
                color="green"
                text-color="white"
                small
                @click="insertSlug(slug.name)"
        >
          {{ slug.name }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row v-if="newTemplate">
      <v-col>
        <MessageTemplateForm :message-template="newTemplate">
          <template v-slot:saveBtn>
            <v-btn block primary color="primary" @click="createOnClick">Add</v-btn>
          </template>
          <template v-slot:deleteBtn>
            <v-btn block primary color="error" @click="newTemplate=null">Cancel</v-btn>
          </template>
        </MessageTemplateForm>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="template in messageTemplates" :key="template.id" cols="12" md="6">
        <MessageTemplateForm :message-template="template" @selectTextArea="selectTextArea" @deleteTemplate="onDeleteTemplate" @saveTemplate="saveOnClick"></MessageTemplateForm>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import MessageTemplateForm from "@/components/admin/message-templates/MessageTemplateForm";
import {botCommentSlugs} from "@/util/globalSettings";
const MessageTemplateRepo = RepositoryFactory.get('messageTemplate')
export default {
  name: "EditMessageTemplates",
  components: {MessageTemplateForm},
  data: () => ({
    messageTemplates: [],
    newTemplate: null,
    selectedTextArea: null,
    availableSlugs: botCommentSlugs,
    addNew: false

  }),
  methods: {
    loadMessageTemplates() {
      MessageTemplateRepo.getMessageTemplates({params: {token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.messageTemplates = res.data;
        })
    },
    newOnClick() {
      this.newTemplate = {};
    },
    createOnClick() {
      console.log('Calling Add on click')
      MessageTemplateRepo.createMessageTemplate(this.newTemplate, {params: {token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.$emit('on-alert', {color: 'success', message: 'Template Created'})
          this.newTemplate = null;
          this.loadMessageTemplates();
        })
    },
    saveOnClick(template) {
      MessageTemplateRepo.updateMessageTemplate(template, {params: {token: this.$store.getters.token}})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            return;
          }
          this.$emit('on-alert', {color: 'success', message: 'Template Updated'})
        })
    },
    selectTextArea(selectedTextArea) {
      this.selectedTextArea = selectedTextArea;
    },
    insertSlug(slugName) {
      let slug = this.availableSlugs.find(i => i.name === slugName);
      let textArea = this.messageTemplates.find(i => i.id === this.selectedTextArea.templateId);
      const el = document.getElementsByName(this.selectedTextArea.refName)[0];
      let cursorPos = el.selectionEnd;
      let currentText = textArea.template
      let newText = `${currentText.substring(0, cursorPos)}${slug.value}${currentText.substring(cursorPos, currentText.length)}`
      textArea.template = newText;
    },
    onDeleteTemplate(id) {
      MessageTemplateRepo.deleteMessageTemplate(id, {params: {token: this.$store.getters.token}})
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
              return;
            }
            this.$emit('on-alert', {color: 'success', message: 'Template deleted'})
            this.newTemplate = null;
            this.loadMessageTemplates();
          })
    }
  },
  mounted() {
    this.loadMessageTemplates();
  }
}
</script>

<style scoped>

</style>